<template>
    <app-layout title="Products">

        <template #fluid>
            <browse-drawer />
        </template>

        <div v-if="search">
            <ol class="breadcrumb bg-transparent p-0" >
                <li class="breadcrumb-item"><a href="">Search</a></li>
                <li class="breadcrumb-item active" aria-current="page">{{$page.props.search}} </li>
            </ol>
        </div>
        <div v-else>
            <ol class="breadcrumb bg-transparent p-0">
                <li class="breadcrumb-item">
                    <a :href="route('products')">Category</a>
                </li>
                <li class="breadcrumb-item" v-for="cat_parent in $page.props.category_parent" :key="cat_parent.id">
                    <a :href="route('products',{id:cat_parent.id})"> {{cat_parent.category_name}}</a>
                </li>
                <li class="breadcrumb-item active" aria-current="page">{{$page.props.breadcrumb}}</li>
            </ol>

        </div>

        <product-grid/>

    </app-layout>
</template>

<script>
    import AppLayout from '@/Layouts/AppLayout'
    import ProductGrid from '@/Layouts/ProductGrid'
    import BrowseDrawer from '@/Layouts/BrowseDrawer.vue'

    export default {
        components: {
            AppLayout,
            ProductGrid,   
            BrowseDrawer,
        },
        props:{      
            products:Array,
            breadcrumb: String,
            category_parent: Array,
            search: String,
        }
    }
</script>